var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9218 8.04547C34.9453 8.38586 34.9453 8.72626 34.9453 9.06979C34.9453 19.5372 26.9921 31.6094 12.4493 31.6094V31.6031C8.15334 31.6094 3.94659 30.3765 0.330078 28.0517C0.954749 28.127 1.58255 28.1647 2.21192 28.1663C5.77207 28.1694 9.23047 26.9725 12.0313 24.7686C8.64807 24.7043 5.68127 22.4941 4.64485 19.2674C5.83 19.4965 7.05116 19.4494 8.2144 19.131C4.52586 18.3843 1.87219 15.1372 1.87219 11.3663C1.87219 11.3317 1.87219 11.2988 1.87219 11.2659C2.97123 11.8792 4.20179 12.2196 5.46052 12.2572C1.98647 9.93096 0.915609 5.30037 3.0135 1.67998C7.02768 6.629 12.9503 9.63763 19.3082 9.95606C18.671 7.20469 19.5415 4.32155 21.5955 2.38743C24.7799 -0.611784 29.7882 -0.458058 32.7817 2.73096C34.5523 2.38116 36.2494 1.73018 37.8025 0.807824C37.2123 2.64155 35.977 4.1992 34.3269 5.189C35.8941 5.0039 37.4252 4.58351 38.8671 3.94194C37.8056 5.53567 36.4686 6.9239 34.9218 8.04547Z",
    fill: "#F9F6FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f054cf04c95f17f9ca2a58e2d618253f.svg";
export { ForwardRef as ReactComponent };